(function () {
    'use strict';

    angular.module("imApp").factory("factoringBuntComponentService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1956,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1960,
                    parameters: edit
                });
            },
            exportFile: function (edit) {
                return $ihttp.post({
                    method: 1959,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
